import { type BaseClassificationRepository } from "../../_Bases/BaseClassificationRepository";
import { type LocalDatabaseClassification } from "../../_Bases/BaseClassificationRepository";
import BaseIndexedDBRepository from "../../Implementations/BaseIndexedDBRepository";

export default abstract class IndexedDBClassificationRepository extends BaseIndexedDBRepository<
    LocalDatabaseClassification
> implements BaseClassificationRepository {
    public search(value: string): Promise<Array<LocalDatabaseClassification>> {
        const needle = value.toLowerCase();

        return this.source
            .filter(classification => {
                return classification.name.toLowerCase().includes(needle);
            })
            .toArray();
    }
}
